<mat-progress-bar
    [appProgressBarColor]="currentChart"
    mode="determinate" [value]="displayNumber" [title]="displayNumber +'% Completado'">
</mat-progress-bar>

<div class="indicator" *ngIf="!displayOptions?.HideIndicator" [style.color]="displayOptions?.IndicatorColor">
  {{getIndicatorText()}}
</div>
